import SpecialistDataBase from "./SpecialistDataBase";
export default class Alert extends SpecialistDataBase {
  constructor(alertObj) {
    super(alertObj);
    if (alertObj) {
      this.alert = alertObj.alert;
    } else {
      this.alert = null;
    }
  }
}
